import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SectionRenderer from './SectionRenderer';
import { contentAPI } from '../../utils/api';

const PageView = ({ slug, backTo = '/', backLabel = 'Back to Home' }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentAPI.getPage(slug).then((data) => {
      setPage(data || {});
      setLoading(false);
    });
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FFFDF9]">
        <div className="pt-32 text-center text-gray-500">Loading…</div>
      </div>
    );
  }

  const hero = page?.hero || {};
  const sections = (page?.sections || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="min-h-screen bg-[#FFFDF9]" data-testid={`page-${slug}`}>
      <section className="relative pt-24 pb-24 min-h-[600px] flex items-center" data-testid="page-hero">
        <div className="absolute inset-0 z-0">
          {hero.image_url && (
            <img src={hero.image_url} alt={hero.title || ''} className="w-full h-full object-cover object-center" />
          )}
          <div className="absolute inset-0 bg-black/55"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 relative z-10 pt-12 w-full">
          <Link
            to={backTo}
            className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-12"
            data-testid="page-back-link"
          >
            <ArrowLeft size={18} />
            <span className="text-sm tracking-wide">{backLabel}</span>
          </Link>
          <div className="text-center">
            {hero.title && (
              <h1
                className="text-5xl md:text-7xl mb-6 tracking-[0.1em] text-white"
                style={{ fontFamily: 'var(--font-serif)', fontWeight: 400 }}
              >
                {hero.title}
              </h1>
            )}
            <div className="w-24 h-px bg-[#C9A86C] mx-auto mb-6"></div>
            {hero.subtitle && (
              <p className="text-white/90 text-xl max-w-2xl mx-auto leading-relaxed">{hero.subtitle}</p>
            )}
          </div>
        </div>
      </section>

      <main>
        {sections.map((s, idx) => (
          <SectionRenderer key={s.id || idx} section={s} pageSlug={slug} />
        ))}
      </main>
    </div>
  );
};

export default PageView;
